import axios from "axios";

// ─── API ──────────────────────────────────────────────────────────────────────
//export const API_URL = "http://localhost:8080/api/";
//export const API_URL = "http://localhost:8090/api/";
//export const API_URL='https://avantthyatest.mecap.mx/api/';
export const API_URL='https://avantthya.mecap.mx/api/';

// ─── Colores legacy ───────────────────────────────────────────────────────────
// Reexportados desde themes/theme.ts como fuente única de verdad.
// TODO: migrar imports directamente a themes/theme.ts.
export { MAIN_COLOR, SECONDARY_COLOR } from '../themes/theme';

// ─── Imágenes / CDN ───────────────────────────────────────────────────────────
const API_URL_CLOUDFRONT = 'https://d2khtgq7ihsmbk.cloudfront.net/';

export const logo_avantthya         = `${API_URL_CLOUDFRONT}Logos/Avantthya/img/avantthya_blanco.png`;
export const entidades_regulatorias = `${API_URL_CLOUDFRONT}Logos/Avantthya/img/icono_entidades_regulatorias.png`;

// Logo rojo — usado en CreditResultsModal (legacy, pendiente mover a CMS)
export const logo_rojo = 'https://resoures-educem.s3.us-west-2.amazonaws.com/Logos/Avantthya/700350cb.png';

// ─── PDFs footer ─────────────────────────────────────────────────────────────
const RESOURCES_FOOTER = 'https://resoures-educem.s3.us-west-2.amazonaws.com/Avantthya/Pages/';

export const aviso_privacidad    = RESOURCES_FOOTER + "aviso-privacidad.pdf";
export const comisiones          = RESOURCES_FOOTER + "comisiones-noviembre-2022.pdf";
export const comite_remuneracion = RESOURCES_FOOTER + "comiteremuneracion.pdf";
export const despachos_cobranza  = RESOURCES_FOOTER + "dcobranza-2.pdf";
